import { useAtomValue } from "jotai/react"
import { atomWithStorage, useHydrateAtoms } from "jotai/utils"
import type { AnswersAtom, EmailCaptureFormType, QuizAtom } from "./types"

const image = {
  src: "",
  alt: "",
  title: "",
  width: 0,
  height: 0,
}

const defaultQuiz: QuizAtom = {
  quiz: {
    id: "",
    key: "",
    name: "",
    title: "",
    description: "",
    image: {
      ...image,
    },
    emailCaptureImage: {
      ...image,
    },
    analysisPageImage: {
      ...image,
    },
    startCta: "",
    analysisDelaySeconds: 5,
    resultCombos: [],
    slug: "",
    productFallbacks: {},
  },
  questions: [],
  routineSteps: [],
  results: [],
}

export const quizAtom = atomWithStorage<QuizAtom>("quiz-data", defaultQuiz)
export const answersAtom = atomWithStorage<AnswersAtom>("quiz-answers", {})
export const emailAtom = atomWithStorage<EmailCaptureFormType>(
  "quiz-email",
  {} as EmailCaptureFormType
)

export const useHydrateQuiz = (data: unknown): void => {
  useHydrateAtoms([[quizAtom, data]])
  useAtomValue(answersAtom)
  useAtomValue(emailAtom)
}
